import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { LANDING } from "@/constants/testIds/wizard";
import { Languages } from "lucide-react";

export default function Header() {
  const { lang, setLang, t } = useLang();

  return (
    <header className="sticky top-0 z-30 border-b border-slate-800/60 bg-slate-950/95 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
          <img
            src="/brand/finch-partners.webp"
            alt="Finch & Partners"
            className="h-11 w-auto object-contain"
            data-testid="brand-logo"
          />
          <div className="hidden leading-tight sm:block border-l border-amber-500/30 pl-3">
            <div className="font-heading text-sm font-semibold tracking-wide text-amber-400">
              FINCH &amp; PARTNERS
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400">
              Strategic Advisoring
            </div>
            <div className="mt-0.5 text-[11px] font-medium text-slate-300">
              {t("app_name")}
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-1 rounded-full border border-slate-700 bg-slate-900 p-1">
          <button
            data-testid={LANDING.langSwitchIT}
            onClick={() => setLang("it")}
            className={`flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-colors ${
              lang === "it" ? "bg-amber-500 text-slate-950" : "text-slate-400 hover:text-slate-200"
            }`}
          >
            <Languages className="h-3.5 w-3.5" strokeWidth={2} /> IT
          </button>
          <button
            data-testid={LANDING.langSwitchEN}
            onClick={() => setLang("en")}
            className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
              lang === "en" ? "bg-amber-500 text-slate-950" : "text-slate-400 hover:text-slate-200"
            }`}
          >
            EN
          </button>
        </div>
      </div>
    </header>
  );
}
